import styled from 'styled-components';
import { ExternalLink } from 'next/components/ui';

export const BeaconTrigger = styled(ExternalLink)`
  --link-text-decoration: none;

  ${({ $light }) =>
    $light &&
    `
      color: var(--white);
      font-weight: var(--bold);
      text-decoration: underline;

      &:hover {
        color: var(--text-tertiary);
      }
    `};
`;
